<template>
  <base-modal
    :show="show"
    @close="close"
  >
    <login-form />
  </base-modal>
</template>
<script>
import { eventBus } from '../app';

export default {
	props: {
		isAuthorised: Boolean
	},
	data() {
		return {
			show: false,
			redirectUrl: null
		};
	},
	created() {
		eventBus.$on('login-required', this.processLogin);
		eventBus.$on('login-success', this.navigate);
	},
	beforeDestroy() {
		eventBus.$off('login-required', this.processLogin);
		eventBus.$off('login-success', this.navigate);
	},
	methods: {
		close() {
			this.show = false;
		},
		processLogin(data) {
			if (Object.hasOwn(data, 'redirectUrl')) {
				this.redirectUrl = data.redirectUrl;
			}

			if (this.isAuthorised) {
				this.navigate();
				return;
			}

			this.show = true;
		},
		navigate() {
			this.close();

			if (this.redirectUrl !== null) {
				window.location = this.redirectUrl;
			}
		}
	}
};
</script>
